import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ assetInventoryId = '', ...params }) => {
  return await dponetAPI.get(`/asset_inventories/${assetInventoryId}`, {
    params,
  })
}

const assetInventory = {
  get,
}

export default assetInventory
